import { render, staticRenderFns } from "./OrdersStatus.vue?vue&type=template&id=30f50265"
import script from "./OrdersStatus.vue?vue&type=script&lang=js"
export * from "./OrdersStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports